module.exports = __webpack_public_path__ + "img/OpenSans-ExtraBoldItalic.20c704bc.svg";